import React, { FunctionComponent } from 'react'
import styles from './DateDialog.module.sass'
import Button from '../../../controls/Button/Button'
import CalendarIcon from 'files/calendar.svg'
import { useBoolean, useDerivedState } from '../../../../utils/hooks'
import { Dialog } from '../../../etc/Dialog/Dialog'
import DatePicker from '../DatePicker/DatePicker'
import OkCancel from '../../../controls/OkCancel/OkCancel'
import { Modifier } from 'react-day-picker'
import clsx from 'clsx'

interface Props {
    className?: string,
    text: string,
    value?: Date,
    onChange: (value: Date) => void,
    disabledDays?: Modifier,
}

const DateDialog: FunctionComponent<Props> = props => {
    const {state, setTrue, setFalse} = useBoolean()
    const [date, setDate] = useDerivedState(props.value ?? null)

    return <div className={clsx(props.className, styles.container)}>
        <div className={styles.text}>Дедлайн</div>
        <Button className={styles.test} onClick={setTrue}>
            <CalendarIcon/>
        </Button>
        {
            state && <Dialog
                onClose={setFalse}
                actions={({onClose}) => <OkCancel
                    onCancel={onClose}
                    disabled={!date}
                    onOk={() => {
                        if (date) {
                            props.onChange(date)
                            setFalse()
                        }
                    }}
                />}
            >
                <DatePicker
                    value={date}
                    onChange={setDate}
                    disabledDays={props.disabledDays}
                />
            </Dialog>
        }
    </div>
}

export default DateDialog